import { Box } from "@mui/system";
import { Chart, Axis, Tooltip, Interval } from "bizcharts";
import { useState } from "react";
const HistogramChart = (props) => {
  const data = [{ label: "0", value: 76962 },
    { label: "1", value: 21617 },
    { label: "2", value: 11924 },
    { label: "3", value: 7972 },
    { label: "4", value: 5780 },
    { label: "5", value: 3274 },
    { label: "6", value: 2117 },
    { label: "7", value: 1119 },
    { label: "8", value: 769 },
    { label: "9", value: 330 },
    { label: "10", value: 319 },
    { label: "11", value: 125 },
    { label: "12", value: 150 },
    { label: "13", value: 65 },
    { label: "14", value: 52 },
    { label: "15", value: 36 },
    { label: "16", value: 35 },
    { label: "17", value: 21 },
    { label: "18", value: 16 },
    { label: "19", value: 13 },
    { label: "20", value: 21 },
    { label: "21", value: 14 },
    { label: "22", value: 11 },
    { label: "23", value: 9 },
    { label: "24", value: 7 },
    { label: "25", value: 5 },
    { label: "26", value: 6 },
    { label: "27", value: 6 },
    { label: "28", value: 7 },
    { label: "29", value: 2 },
    { label: "30", value: 1 },
    { label: "31", value: 1 },
    { label: "33", value: 3 },
    { label: "34", value: 1 },
    { label: "35", value: 1 },
    { label: "36", value: 1 },
    { label: "37", value: 1 }
  ];
  const scale = {
    label: {
      tickInterval: 1,
    },
    value: { formatter: (val) => " " + val.toLocaleString() },
  };
  const [canvas, setCanvas] = useState(undefined);

  return (
    <Box>
      <Box>
        <Chart
          height={300}
          autoFit
          scale={scale}
          data={data}
          binWidth={1}
          interactions={["active-region"]}
          onGetG2Instance={(chartInstance) => {
            setTimeout(() => {
              setCanvas(chartInstance.canvas);
            }, 1000);
          }}
        >
          {" "}
          <Axis
            name="value"
            label={{
              formatter: (val) => {
                return val.toLocaleString();
              },
              style: {
                fontFamily: "Roboto Condensed, sans-serif",
              },
            }}
          />{" "}
          <Axis
            name="label"
            label={{
              style: {
                fontFamily: "Roboto Condensed, sans-serif",
              },
            }}
          />{" "}
          <Interval
            position="label*value"
            size={16}
            style={{
              stroke: "#F9B112",
              fill: "#F9B112",
              fillOpacity: 1,
              lineWidth: 1,
            }}
          />{" "}
          <Tooltip shared>
            {(title, items) => {
              const filtered = data.filter((d) => d["label"] === title);
              return (
                <div
                  id="#tooltipWrap"
                  style={{
                    padding: "5px 10px 10px 5px",
                    width: "auto",
                    color: "#22294D",
                    fontFamily: "Roboto Condensed",
                    opacity: "1",
                  }}
                >
                  <div
                    className="g2-tooltip-title"
                    style={{
                      fontSize: "medium",
                      paddingBottom: "0",
                      fontWeight: "bold",
                    }}
                  >
                    {filtered[0]["label"]} Results
                  </div>
                  <ul className="g2-tooltip-list">
                    <li style={{ padding: "2px 0" }} data-index="0">
                      {filtered[0]["value"].toLocaleString()} samples
                    </li>
                  </ul>
                </div>
              );
            }}
          </Tooltip>
        </Chart>
      </Box>
    </Box>
  );
};

export default HistogramChart;
